import { esErrorApi } from '../api';

/**
 * Qué se le muestra a una persona cuando el login falla.
 *
 * # LA REGLA: EL MENSAJE NO DICE SI LA CUENTA EXISTE
 *
 * El backend contesta **exactamente lo mismo** para un email inexistente y para
 * una contraseña equivocada (`401 credenciales_invalidas`), y hasta paga un
 * bcrypt de descarte cuando el email no existe para que tampoco lo delate el
 * tiempo de respuesta. Todo eso se tira a la basura si el front muestra "ese
 * usuario no existe": quien tenga una lista de emails puede averiguar cuáles
 * son clientes de un servicio de facturación con solo probarlos.
 *
 * De ahí salen dos decisiones que se ven en el código de abajo:
 *
 * 1. **Un solo mensaje para todo el `401`.** No hay ninguna rama que distinga
 *    email de contraseña, porque no hay ningún dato con el que distinguirlos —
 *    y no hay que ir a buscarlo.
 * 2. **No se muestra `error.detalle` del backend.** Es texto libre que puede
 *    cambiar de redacción sin aviso; si alguien alguna vez escribe ahí algo más
 *    específico, el front no lo repite. El mensaje se decide acá, a partir del
 *    **código**, que es lo estable.
 */

const GENERICO = 'No se pudo iniciar sesión. Probá de nuevo.';

/** Convierte lo que haya fallado en un texto mostrable. */
export function mensajeDeLogin(error: unknown): string {
  if (!esErrorApi(error)) {
    return GENERICO;
  }
  switch (error.codigo) {
    case 'credenciales_invalidas':
      // Único mensaje del 401. Nombra los dos campos y no acusa a ninguno.
      return 'Email o contraseña incorrectos.';
    case 'request_invalida':
      return 'Completá el email y la contraseña.';
    case 'sin_conexion':
      return 'No se pudo contactar al servicio. Revisá tu conexión e intentá de nuevo.';
    case 'error_interno':
      return 'El servicio tuvo un problema. Intentá de nuevo en un momento.';
    default:
      return GENERICO;
  }
}
